export default __webpack_public_path__ + "static/media/ActiveLiveChannel.014f942c.svg";